module.exports = __webpack_public_path__ + "img/lv_failure_5.ba8c768f.png";